import React from 'react';
import { Price } from '../../PaymentGateway/interfaces/Price';

export type ProductType = 'PREMIUM' | 'TIP';

export interface Shop {
  type: ProductType;
  tipsterInfo: TipsterInfo;
  products: ShopProduct[];
  selectedProduct: ShopProduct;
}

export interface IShopProduct {
  render(): React.ReactElement<{}>;
}

export interface WithComponent {
  component: React.ReactElement<{}>;
}

export interface WithPrice {
  price: Price;
  priceWithDiscount: Price;
  discountPercentage: number;
}

export abstract class ShopProduct implements IShopProduct, WithComponent {
  abstract component: React.ReactElement<{}>;

  public render(): React.ReactElement<{}> {
    return this.component;
  }
}

export interface TipsterInfo {
  alias: string;
  avatar_id: string;
  avatar_url: string;
  background_image_id: string;
  bio: string;
  biography: any[];
  country_id: string;
  deleted_at: null | string;
  has_premium: boolean;
  id: string;
  is_in_trial: boolean;
  media_files_ids: string[];
  name: string;
  profile_stats_period: string;
  ranking_position: number;
  ranking_score: number;
  share_channel_url: string;
  share_premium_url: string;
  sport_code: string;
  sport_ids: string[];
  status_id: string;
  status_updated_at: string;
  referral_code: string;
}
